// Reference data shared across Sprint 2 modules.
export const MARKETPLACES = [
  "Shopify",
  "Amazon",
  "eBay",
  "Walmart",
  "Etsy",
  "WooCommerce",
  "TikTok Shop",
  "Custom",
];

export const CURRENCIES = ["USD", "EUR", "GBP", "CAD", "AUD", "INR", "JPY", "SGD"];

export const TIMEZONES = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Toronto",
  "Europe/London",
  "Europe/Berlin",
  "Asia/Kolkata",
  "Asia/Singapore",
  "Australia/Sydney",
  "UTC",
];

// Roles an admin can assign when inviting a user (excludes platform super-admin).
export const ASSIGNABLE_ROLES = [
  "THREE_PL_OWNER",
  "WAREHOUSE_MANAGER",
  "WAREHOUSE_STAFF",
  "VA_AGENCY_OWNER",
  "VA_MANAGER",
  "VA_STAFF",
  "CLIENT",
];

export const VA_STAFF_ROLES = ["VA_AGENCY_OWNER", "VA_MANAGER", "VA_STAFF"];

export const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

// Tone lookups for status pills.
export const USER_STATUS_TONE = {
  active: "green",
  pending: "amber",
  inactive: "neutral",
  revoked: "red",
};

export const USER_STATUS_LABEL = {
  active: "Active",
  pending: "Pending Invitation",
  inactive: "Inactive",
  revoked: "Revoked",
};

export const LOGIN_STATUS_TONE = {
  none: "neutral",
  pending: "amber",
  active: "green",
  disabled: "red",
};

export const LOGIN_STATUS_LABEL = {
  none: "No login",
  pending: "Pending Invitation",
  active: "Active",
  disabled: "Disabled",
};

// --- Sprint 3: operations status maps ---
export const ORDER_STATUS_META = {
  pending: { label: "Pending", tone: "neutral" },
  ready: { label: "Ready", tone: "blue" },
  shipped: { label: "Shipped", tone: "green" },
  quantity_problem: { label: "Quantity Problem", tone: "red" },
  didnt_arrive: { label: "Didn't Arrive", tone: "amber" },
};

export function orderDisplayStatus(order) {
  if (order.status === "pending") return order.is_ready ? "ready" : "pending";
  return order.status;
}

export const INVENTORY_STATUS_META = {
  in_stock: { label: "In stock", tone: "green" },
  low: { label: "Low stock", tone: "amber" },
  out: { label: "Out of stock", tone: "red" },
};

export const INVENTORY_ADJUST_TYPES = [
  { value: "add_stock", label: "Add Stock", mode: "add" },
  { value: "remove_stock", label: "Remove Stock", mode: "subtract" },
  { value: "count_correction", label: "Stock Count Correction", mode: "set" },
  { value: "damaged", label: "Damaged", mode: "subtract" },
  { value: "lost", label: "Lost", mode: "subtract" },
  { value: "other", label: "Other", mode: "add" },
];

export const RETURN_STATUS_META = {
  pending: { label: "Pending", tone: "amber" },
  confirmed: { label: "Confirmed", tone: "green" },
};

export const RETURN_CONDITION_META = {
  sellable: { label: "Sellable", tone: "green" },
  non_sellable: { label: "Non-Sellable", tone: "red" },
  mixed: { label: "Mixed", tone: "blue" },
};

export const INBOUND_STATUS_META = {
  expected: { label: "Expected", tone: "neutral" },
  receiving: { label: "Partially Received", tone: "blue" },
  partially_received: { label: "Partially Received", tone: "blue" },
  received: { label: "Received", tone: "green" },
  problem: { label: "Problem", tone: "red" },
};
